import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
} from "@mui/material";
import getOktaConfig from "../../oktaConfig";

interface CorsErrorModalProps {
  corsErrorModalOpen: boolean;
  setCorsErrorModalOpen: (open: boolean) => void;
}

const CorsErrorModal: React.FC<CorsErrorModalProps> = ({
  corsErrorModalOpen,
  setCorsErrorModalOpen,
}) => {
  // Build URL to "Trusted Origins" page in Admin panel
  const oktaConfig = getOktaConfig();
  const { issuer } = oktaConfig['oidc'];
  const baseUrl = issuer.split("/oauth2")[0];
  const hostParts = new URL(baseUrl).host.split(".");
  hostParts[0] += "-admin";
  const adminHost = hostParts.join(".");
  const corsAdminUrl = `https://${adminHost}/admin/access/api/trusted_origins`;

  // URL to guide for enabling CORS
  const guideUrl =
    "https://developer.okta.com/docs/guides/enable-cors/granting-cors/";

  return (
    <Dialog
      open={corsErrorModalOpen}
      onClose={() => setCorsErrorModalOpen(false)}
      aria-labelledby="cors-error-title"
    >
      <DialogTitle id="cors-error-title">Network Error</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          It looks like a logout API call resulted in a CORS error.
        </Typography>
        <Typography variant="body1">
          You may need to add your origin{" "}
          <strong>{window.location.origin}</strong> to the list of trusted
          origins in your{" "}
          <Link href={corsAdminUrl} target="_blank" rel="noopener">
            Okta Administrator Dashboard
          </Link>
          .
        </Typography>
        <Typography variant="body1">
          Read{" "}
          <Link href={guideUrl} target="_blank" rel="noopener">
            this guide
          </Link>{" "}
          for more information.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setCorsErrorModalOpen(false)} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CorsErrorModal;
